import { render, staticRenderFns } from "./ResetFiltersButton.vue?vue&type=template&id=36d0267a&scoped=true&"
import script from "./ResetFiltersButton.vue?vue&type=script&lang=js&"
export * from "./ResetFiltersButton.vue?vue&type=script&lang=js&"
import style0 from "./ResetFiltersButton.vue?vue&type=style&index=0&id=36d0267a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d0267a",
  null
  
)

export default component.exports